import { isEmbedded, storageKey } from "@/utils/embed";
import router from "../../router";

/**
 * A státuszhoz tartozó, olvasható szöveg (`request.403`, `request.500`...). A hibakezelő
 * nem komponens, tehát nincs `this.$t`-je.
 *
 * A fordítót CSAK híváskor kérjük el: a `translations/i18n` modul maga is behúzza a
 * store-t, a store pedig a moduljain át ezt a fájlt - egy felső szintű import tehát körbe
 * érne, és az alkalmazás indulásakor „Cannot set properties of undefined (setting '$t')"
 * hibával állna meg. Megmérve 2026-09-20, a fehér képernyőt az e2e fogta meg.
 */
const statusMessage = function (status) {
    const t = require('@/translations/i18n').default.global.t;
    const key = 'request.' + (status || 'error');
    const text = t(key);

    return (text === key ? t('request.error') : text).ucFirst();
};

export const changes = function (payload, item) {
    const id = payload.id;

    const fileProps = Object.keys(payload).filter(prop => {
        return prop.endsWith('_file') || prop === 'file';
    })

    const fileLists = Object.keys(payload).filter(prop => {
        return payload[prop] instanceof FileList
    })

    const files = {}

    for (let prop of fileProps) {
        files[prop] = payload[prop]
        delete payload[prop]
    }

    fileLists.forEach(list => {
        if (payload[list].length > 1) {
            files[list] = [...payload[list]];
        }
        if (payload[list].length === 1) {
            files[list] = payload[list][0]
        }
    })

    let data = JSON.parse(JSON.stringify(payload));

    delete data.id;

    for (let prop in payload) {
        if (
            item[prop] === payload[prop]
            || (
                Array.isArray(payload[prop])
                && Array.isArray(item[prop])
                && JSON.stringify(item[prop]) === JSON.stringify(payload[prop])
            )
            || (
                typeof item[prop] === 'object' && typeof payload[prop] === 'object'
                && ((!item[prop] && !payload[prop]) || JSON.stringify(item[prop]) === JSON.stringify(payload[prop]))
            )
        ) {
            delete data[prop];
        }
    }

    let base = {}

    if (payload?.query) {
        base = JSON.parse(JSON.stringify(payload.query));
    }

    // a JSON-küldés jelzője (axios.js) nem adat: akkor is menjen, ha a tárolt elemen már rajta van
    if (payload.__json === true) data.__json = true;

    data = Object.assign(base || {}, data, files);

    return {
        id: id,
        data: data
    }
}
export const handleError = function (e, commit) {
    // lejárt munkamenet után visszatartott kérés: nincs mit kiírni
    if (e && e.__CANCEL__) {
        loading(commit, false)
        return
    }

    if (e && e.response && e.response.data && e.response.data.errors) {
        commit('SET_ERRORS', e.response.data.errors);
    }

    // Lejárt jelszó: amíg nem cserél, MINDEN hívás így tér vissza — a háttérben futó
    // lekérdezések is. A képernyő már megmondta, miért; egy értesítés hívásonként csak
    // eltakarná az egyetlen dolgot, amit tenni lehet.
    if (e?.response?.status === 423 && e?.response?.data?.code === 'password_expired') {
        loading(commit, false)
        return
    }

    const status = e?.response?.status

    // lejárt munkamenet: az axios egyszer szól és a belépőre visz
    if (status === 401 || status === 419) {
        loading(commit, false)
        return
    }

    let message = e?.response?.data?.message || ''

    // Kiszolgáló-hiba: a nyers üzenet a kivétel szövege (néha SQL-részlet), a felhasználónak
    // nem mond semmit. Egységes szöveget mutatunk, a részlet a naplóban marad.
    // Üzenet nélküli válasznál pedig eddig ÜRES buborék jelent meg - a jogosultsági hiba
    // tipikusan ilyen volt.
    if (!message || status >= 500) {
        message = statusMessage(status)
    }

    // A kiszolgáló hibája nem olvasható el három másodperc alatt, és nem is lehet rá
    // reagálni: az értesítés ilyenkor tovább marad a képernyőn.
    commit('app/ADD_ALERT', {
        message: message,
        style: 'error',
        icon: 'error',
        countdown: status >= 500 ? 10000 : 3000
    }, { root: true })
    loading(commit, false)
    switch (status) {
        case 302:
            router.push(e.response.data.redirect);
            break;
    }
}

export const loading = function (commit, loading = true) {
    commit('app/SET_LOADING', loading, {root: true})
    commit('SET_LOADING', loading)
}

export const customLoading = function (commit, mutation, loading = true) {
    commit(mutation, loading);
}

export const alert = function (commit, message, style = 'success', icon = 'success', countdown = 3000) {
    commit('app/ADD_ALERT', {
        message: message,
        style: style,
        icon: icon,
        countdown: countdown
    }, { root: true });
}

// A Globalixba ágyazott keret (#273) a localStorage-ot nem írja és nem olvassa: élesen közös a normál
// XMED-füllel, és a keret belépése azt írná át (l. utils/embed.js). A fül sessionStorage-át is csak
// előtagos kulccsal (`storageKey`) használja: ugyanazon a fülön a teljes lapos XMED-é is.
export function destroyLocal(key) {
    if (!isEmbedded()) {
        window.localStorage.removeItem(key);
    }
    window.sessionStorage.removeItem(storageKey(key));
}

export function storeLocal(key, value) {
    if (!isEmbedded()) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
    window.sessionStorage.setItem(storageKey(key), JSON.stringify(value));
}

export function getLocal(key) {
    const item = window.sessionStorage.getItem(storageKey(key)) || (isEmbedded() ? null : window.localStorage.getItem(key))

    if (item !== null) {
        return JSON.parse(item)
    }

    return null
}
